<ng-container>
  <div id="switch_question">
    @switch (question.question.questionType.name.trim().toLowerCase()) { @case
    ('information') {
    <div><app-information [question]="question"></app-information></div>
    } @case ('radiobutton') {
    <div><app-radiobutton [question]="question"></app-radiobutton></div>
    } @case ('multiplechoice') {
    <div><app-multiplechoice [question]="question"></app-multiplechoice></div>
    } @case ('signature') {
    <div><app-signature [question]="question"></app-signature></div>
    } @case ('label') {
    <div><app-label [question]="question"></app-label></div>
    } @case ('cityonsiteattachments') {
    <div>
      <app-cityonsite-attachments
        [question]="question"
      ></app-cityonsite-attachments>
    </div>
    } @case ('cityonsiteprofile') {
    <div>
      <app-cityonsiteprofile [question]="question"></app-cityonsiteprofile>
    </div>
    } @case ('text') {
    <div><app-text [question]="question"></app-text></div>
    } }
  </div>
  <div class="divider"></div>
</ng-container>
